import Vue from "vue";
import Router from "vue-router";
import core from "@/core";
import store from "@/store";

const Login = () => import("@/views/Login");
const Logout = () => import("@/views/Logout");
const Register = () => import("@/views/Register");
const NotFound = () => import("@/views/errors/NotFound");
const NotSupportBrowser = () => import("@/views/errors/NotSupportBrowser");

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const Control = () => import("@/views/Control");
const Farm = () => import("@/views/Farm");
const FarmNotSelected = () => import("@/views/FarmNotSelected");

const MonitoringIntegrated = () => import("@/views/monitoring/Integrated");
const MonitoringArea = () => import("@/views/monitoring/Area");
const MonitoringSensor = () => import("@/views/monitoring/Sensor");

const AnalysisEnvRecomm = () => import("@/views/analysis/EnvRecomm");
const AnalysisEnvVpdHd = () => import("@/views/analysis/EnvVpdHd");
const AnalysisFlowering = () => import("@/views/analysis/Flowering");
const AnalysisGrowthIndex = () => import("@/views/analysis/GrowthIndex");
const AnalysisDisease = () => import("@/views/analysis/Disease");
const AnalysisGrowthMeasure = () => import("@/views/analysis/GrowthMeasure");

Vue.use(Router);

const routes = [
  {
    path: "*",
    name: "notFound",
    component: NotFound,
    meta: {
      title: "스마트팜",
    },
  },
  {
    path: "/error/not-support-browser",
    name: "notSupportBrowser",
    component: NotSupportBrowser,
    meta: {
      title: "스마트팜",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "스마트팜 - 로그인",
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "스마트팜 - 회원가입",
    },
  },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: {
      title: "스마트팜 - 회원가입",
      roles: ["farmer"],
    },
  },
  {
    path: "/farm-not-selected",
    name: "FarmNotSelected",
    component: FarmNotSelected,
    meta: {
      title: "스마트팜 - 농장 선택",
      roles: ["farmer"],
    },
  },
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home",
    component: TheContainer,
    meta: {
      title: "스마트팜",
      roles: ["farmer"],
    },
    children: [
      {
        path: "dashboard",
        name: "대시보드",
        component: Dashboard,
        meta: {
          title: "스마트팜 - 대시보드",
          roles: ["farmer"],
          facilityIdRequired: true,
        },
      },
      {
        path: "control",
        name: "제어기 설정",
        component: Control,
        meta: {
          title: "스마트팜 - 제어기 설정",
          roles: ["farmer"],
          facilityIdRequired: true,
        },
      },
      {
        path: "farm",
        name: "농가관리",
        component: Farm,
        meta: {
          title: "스마트팜 - 농가관리",
          roles: ["farmer"],
        },
      },
      {
        path: "monitoring",
        redirect: "/monitoring/integrated",
        name: "모니터링",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          title: "스마트팜 - 모니터링",
          roles: ["farmer"],
        },
        children: [
          {
            path: "integrated",
            name: "통합 모니터링",
            component: MonitoringIntegrated,
            meta: {
              title: "스마트팜 - 통합 모니터링",
              roles: ["farmer"],
              facilityIdRequired: true,
            },
          },
          {
            path: "area",
            name: "동(구역별) 조회",
            component: MonitoringArea,
            meta: {
              title: "스마트팜 - 동(구역별) 조회",
              roles: ["farmer"],
              facilityIdRequired: true,
            },
          },
          {
            path: "sensor",
            name: "센서별 모니터링",
            component: MonitoringSensor,
            meta: {
              title: "스마트팜 - 센서별 모니터링",
              roles: ["farmer"],
              facilityIdRequired: true,
            },
          },
        ],
      },
      {
        path: "analysis",
        redirect: "/analysis/env",
        name: "데이터 분석",
        meta: {
          title: "스마트팜 - 데이터 분석",
          roles: ["farmer"],
        },
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "env",
            redirect: "/analysis/env/recomm",
            name: "온실환경 분석",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: {
              title: "스마트팜 - 온실환경 분석",
              roles: ["farmer"],
            },
            children: [
              {
                path: "recomm",
                name: "환경분석 및 추천",
                component: AnalysisEnvRecomm,
                meta: {
                  title: "스마트팜 - 환경분석 및 추천",
                  roles: ["farmer"],
                  facilityIdRequired: true,
                },
              },
              {
                path: "vpd-hd",
                name: "VPD/HD 분석",
                component: AnalysisEnvVpdHd,
                meta: {
                  title: "스마트팜 - VPD/HD 분석",
                  roles: ["farmer"],
                  facilityIdRequired: true,
                },
              },
            ],
          },
          {
            path: "growth",
            redirect: "/analysis/growth/index",
            name: "작물생육 분석",
            component: {
              render(c) {
                return c("router-view");
              },
            },
            meta: {
              title: "스마트팜 - 작물생육 분석",
              roles: ["farmer"],
            },
            children: [
              {
                path: "index",
                name: "작물생육 지표",
                component: AnalysisGrowthIndex,
                meta: {
                  title: "스마트팜 - 작물생육 지표",
                  roles: ["farmer"],
                  facilityIdRequired: true,
                },
              },
              {
                path: "flowering",
                name: "개화 및 착과",
                component: AnalysisFlowering,
                meta: {
                  title: "스마트팜 - 개화 및 착과",
                  roles: ["farmer"],
                  facilityIdRequired: true,
                },
              },
              {
                path: "measure",
                name: "작물생육 측정",
                component: AnalysisGrowthMeasure,
                meta: {
                  title: "스마트팜 - 작물생육 측정",
                  roles: ["farmer"],
                  facilityIdRequired: true,
                },
              },
            ],
          },
          {
            path: "disease",
            name: "병해충 진단",
            component: AnalysisDisease,
            meta: {
              title: "스마트팜 - 병해충 진단",
              roles: ["farmer"],
            },
          },
        ],
      },
    ],
  },
];

const options = {
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
};

const base = process.env.BASE_URL;
if (base != null && base.length > 0) {
  options.base = base;
}

const router = new Router(options);

function childrenRouteMap(path, children) {
  children.forEach((data) => {
    let slash = "";
    if (path.substr(path.length - 1, path.length) !== "/") {
      slash = "/";
    }
    const _path = path + slash + data.path;
    if (data.children != null) {
      childrenRouteMap(_path, data.children);
    } else {
      if (routeMap.get(_path) != null) {
        console.log("중복 path : ", _path);
      }
      routeMap.set(_path, data);
    }
  });
}

const routeMap = new Map();
routes.forEach((data) => {
  if (data.children != null) {
    childrenRouteMap(data.path, data.children);
  } else {
    if (routeMap.get(data.path) != null) {
      console.log("중복 path : ", data.path);
    }
    routeMap.set(data.path, data);
  }
});

const routerBeforeTask = store.state.routerBeforeTask;
router.beforeEach(async (to, from, next) => {
  if (!routerBeforeTask.isRouterNext()) {
    //console.log("ignore router event");
    next(false);
    return;
  } else {
    const viewerContainer = document.querySelector(
      ".viewer-container.viewer-in",
    );
    if (viewerContainer != null) {
      next(false);
      const button = viewerContainer.querySelector(".viewer-button");
      if (button != null) {
        button.click();
      }
      return;
    }
  }

  //console.log("from   : ", from);
  //console.log("to     : ", to);
  core.loader.show("페이지 로딩중...");

  // console.log("from " + from.path + " -> to : " + to.path);
  document.title = await beforeEach(to, from, next);
  core.loader.hide();
});

function routerResult(next, path) {
  next({ path: path });
  //console.log("next : ", path);
  const route = routeMap.get(path);
  if (route != null && route.meta != null && route.meta.title != null) {
    return route.meta.title;
  } else "";
}

async function beforeEach(to, from, next) {
  const state = store.state;
  if (state.auth.user) {
    // 로그인 중인 사용자
    if (to.meta.roles != null) {
      // 로그인 사용자 접근 가능 페이지일 경우 이동

      if (to.meta.facilityIdRequired) {
        // 농장 정보 가져오기
        const facilityList = await store.dispatch("getFacilityList");
        if (state.app.facilityId == null) {
          if (facilityList.length > 0) {
            return routerResult(next, "/farm-not-selected");
          } else {
            return routerResult(next, "/farm");
          }
        }
      }
      next();
      // if (to.meta.companyOptions != null) {
      //   if (to.meta.companyOptions.indexOf("exists") > -1) {
      //     console.log("user company exists ", state.auth.user.company != null);
      //     if (state.auth.user.company != null) {
      //       const approval = state.auth.user.company.lastApproval;
      //       if (approval != null && approval.type === "ALLOW") {
      //         next();
      //       } else {
      //         if (to.meta.companyOptions.indexOf("approval") > -1) {
      //           next();
      //         } else {
      //           return routerResult(next, "/company/waiting-approval");
      //         }
      //       }
      //     } else {
      //       return routerResult(next, "/company");
      //     }
      //   } else {
      //     if (state.auth.user.company != null) {
      //       return routerResult(next, "/");
      //     } else {
      //       next();
      //     }
      //   }
      // } else {
      //   next();
      // }
    } else {
      // 비로그인 사용자 접근 가능 페이지일 경우 이동
      if (to.path.toLowerCase() === "/login") {
        // 로그인중인 사용자가 로그인 페이지 접근시 이동
        return routerResult(next, "/");
      } else {
        next();
      }
    }
  } else {
    // 비로그인 중인 사용자 세션 확인
    const user = await store.dispatch("auth/getUser");
    if (user != null) {
      // 농장 정보 가져오기
      const facilityList = await store.dispatch("getFacilityList");
      if (state.app.facilityId == null) {
        if (facilityList.length > 0) {
          return routerResult(next, "/farm-not-selected");
        } else if (!to.path.toLowerCase() !== "/analysis/disease") {
          return routerResult(next, "/analysis/disease");
        }
      }
      // 세션이 존재하면 로그인중인 사용자로 변경되어 재호출 처리
      await beforeEach(to, from, next);
    } else {
      if (to.meta.roles != null) {
        // 로그인 사용자 접근 가능 페이지일 경우 메인 페이지로 이동
        return routerResult(next, "/login");
      } else {
        next();
      }
    }
  }
  if (to.meta != null && to.meta.title != null) {
    return to.meta.title;
  } else {
    return "";
  }
}

export default router;
